export const getDealsEndpoint = () => __SERVER__ ? process.env.DEALS_INTERNAL_ENDPOINT : process.env.DEALS_ENDPOINT;

export const getAdPlatformApi = () => (`${getDealsEndpoint()}/inventory/data/json/`);
